import axios from 'axios';
// const BaseUrl = 'http://localhost:3001'
const BaseUrl = 'https://everpay-frontsite-api.herokuapp.com'

const sendContactFrom = async (data) => {
    return axios.post(`${BaseUrl}/contact-us`, data)
}

export default { sendContactFrom };
